<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import NavLayout from "./NavLayout.vue";

const route = useRoute();
const isLoginPage = computed(() => route.name === "login");
</script>

<template>
    <section v-if="isLoginPage" class="w-full min-h-[100dvh]">
        <slot></slot>
    </section>
    <section v-else class="flex items-center justify-center w-full h-full">
        <section
            class="flex flex-col justify-start h-auto py-24 items-center w-full bg-custom-background sm:bg-custom-white sm:py-16"
        >
            <NavLayout />
            <div class="w-full h-auto">
                <slot></slot>
            </div>
        </section>
    </section>
</template>
